// extracted by mini-css-extract-plugin
export default {"settingContainer":"setting_settingContainer__7sUO5","listItem":"setting_listItem__67C1F","linkTitle":"setting_linkTitle__mKCGR","description":"setting_description__7L-Tw"};